export const createTableFilters = (items) => {
    return items.map((item) => { return { text: item, value: item } })
}

export const createTableFiltersForMutualFunds = (items) => {
    return items.map((item) => { return { text: item.fund_name, value: item._id } })
}